module.exports = [{
      plugin: require('../../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-76055934-6"},
    },{
      plugin: require('../../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[{"resolve":"/opt/build/repo/@pauliescanlon/gatsby-mdx-routes","id":"c754084e-dd96-5f48-97c7-ac269c451a61","name":"@pauliescanlon/gatsby-mdx-routes","version":"0.0.11","pluginOptions":{"plugins":[]},"nodeAPIs":["onCreateNode"],"browserAPIs":[],"ssrAPIs":[]}],"defaultLayouts":{"default":"/opt/build/repo/demo/src/layouts/layout.js"}},
    }]
